import { render, staticRenderFns } from "./lab-product-selector.vue?vue&type=template&id=f7f3895c"
import script from "./lab-product-selector.vue?vue&type=script&lang=js"
export * from "./lab-product-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports